<template>
  <b-container>
    <h1>{{ $t("workflow.processField.processFilled") }}</h1>
    <b-row>
      <!-- {{ tableFilters }} -->
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div
                v-if="
                  field.key == 'dateCreate' || field.key == 'stageDateUpdate'
                "
              >
                <b-form-input
                  class="dateCreate"
                  type="date"
                  v-model="tableFilters[field.key]"
                />
              </div>
              <div v-else-if="field.key == 'active'">
                <b-form-select
                  v-model="tableFilters[field.key]"
                  id="perPageSelect"
                  :options="optionsActive"
                ></b-form-select>
              </div>
              <b-form-input
                v-else-if="field.key != 'actions'"
                v-model="tableFilters[field.key]"
                :placeholder="'Buscar por ' + field.label"
                class="idStyle"
              />
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <!-- {{ data.item.permissions }} -->
          <router-link :to="'/workflow/process/filledDetail/' + data.item.id">
            <b-button size="sm">{{ $t("geral.detalhes") }}</b-button>
          </router-link>
          <b-button
            class="ml-2"
            size="sm"
            @click="openStoryModal(data.item)"
            :disabled="!canViewStory(data.item.permissions)"
            >Histórico</b-button
          >
          <b-button
            class="ml-2"
            size="sm"
            :disabled="!canViewLocalization(data.item.permissions)"
            @click="openMap(data.item.latitude, data.item.longitude)"
            >Localização</b-button
          >
        </template>
      </b-table>
    </b-row>

    <!-- Mapa -->
    <workflow-map-modal ref="workflowMap"></workflow-map-modal>
    <!-- Histórico -->
    <process-story-modal ref="workflowStory"></process-story-modal>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>

    <!-- <pre class="language-json"><code>model: {{ model  }}</code></pre> -->
  </b-container>
</template>
<script>
export default {
  name: "ProcessFilled",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
  'workflow-map-modal': () => import("@/components_rms/workflow/WorkflowMapModal.vue"),
    ProcessStoryModal: () =>
      import("@/components_rms/workflow/Process/ProcessStoryModal.vue"),
  },
  data() {
    return {
      model: [],
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "nowrapActions",
        },
        {
          key: "id",
          sortable: false,
          label: "Id",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "processName",
          sortable: false,
          label: "Processo",
          tdClass: "nowrap",
        },
        {
          key: "stageName",
          sortable: false,
          label: "Etapa",
          tdClass: "nowrap",
        },
        {
          key: "userName",
          sortable: false,
          label: "preenchedor",
          tdClass: "nowrap",
        },
        {
          key: "dateCreate",
          sortable: false,
          label: "Data criação",
          tdClass: "nowrap",
        },
        {
          key: "stageDateUpdate",
          sortable: false,
          label: "Data alteração",
          tdClass: "nowrap",
        },
        {
          key: "active",
          sortable: false,
          label: "Ativo",
          tdClass: "table-col-dinamic-width",
        },
      ],
      isBusy: false,
      tableFilters: {
        active: "1",
        userName: "",
        processName: "",
        dateCreate: "",
        stageName: "",
        id: "",
        stageDateUpdate: "",
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      optionsActive: [
        { value: "", text: "Todos" },
        { value: "1", text: "Sim" },
        { value: "0", text: "Não" },
      ],
    };
  },
  create() {},
  computed: {},
  methods: {
    canViewStory(permission) {
      if (permission.administrador) return true;
      if (permission.gestor) return true;
      if (permission.advancedOperator) return true;
      return false;
    },
    canViewLocalization(permission) {
      if (permission.administrador) return true;
      if (permission.gestor) return true;
      if (permission.advancedOperator) return true;
      return false;
    },
    openMap(latitude, longitude) {
      this.$refs.workflowMap.openMap(latitude, longitude);
    },
    openStoryModal(item) {
      // console.log(item)
      this.$refs.workflowStory.openModal(item.id);
    },
    myProvider(ctx, callback) {
      // console.log("ctx");
      // console.log(ctx);
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        active: ctx.filter.active,
        userName: ctx.filter.userName,
        processName: ctx.filter.processName,
        draft: ctx.filter.draft,
        stageName: ctx.filter.stageName,
        id: ctx.filter.id,
        dateCreate: ctx.filter.dateCreate,
        stageDateUpdate: ctx.filter.stageDateUpdate,
      };
      this.$apiWorkflow
        .post("/filled/list/", apiParam)
        .then((response) => {
          const items = response.data.items;
          // console.log(items);
          this.model = items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
  },
};
</script>
